module.exports = __webpack_public_path__ + "img/icon_home_zhibo.d08ace51.png";